import * as React from 'react';

const LockFillSlimSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.668 6.667H3.334v8h9.334v-8zm-4.666 2a1.333 1.333 0 00-.666 2.488v1.512h1.333v-1.512a1.333 1.333 0 00-.667-2.488z"
            fill="#39364F"
        />
        <path
            d="M11.333 4.535H10a2 2 0 10-4 0H4.667a3.333 3.333 0 016.666 0zM10 4.535h1.333v2.131H10zM4.667 4.535H6v2.131H4.667z"
            fill="#39364F"
        />
    </svg>
);

LockFillSlimSvg.displayName = 'LockFillSlimSvg';
export default LockFillSlimSvg;
